<template>
  <q-chip
    color="secondary"
    :icon="connectedClinic.integration ? undefined: 'today'"
    :size="size"
    :disable="disable"
    data-e2e="chip-linked-appointment"
    clickable
    square
    outline
    @click.stop="onClick"
  >
    <q-avatar v-if="connectedClinic.integration">
      <img
        :src="getIntegrationLogo(connectedClinic.integration)"
        class="q-pa-xs"
      >
    </q-avatar>
    {{ formattedAppointmentDate }}
    <div
      v-if="isGroupSession"
      class="q-pl-sm"
    >
      <q-icon
        color="positive"
        size="xs"
        name="groups"
      />
    </div>
    <q-spinner-dots
      v-if="appointmentInProgress"
      class="q-ml-sm"
    />
    <div
      v-else-if="showIntegrationStatus"
      class="q-pl-sm"
    >
      <q-icon
        color="positive"
        size="xs"
        :name="integrationStatusIcon"
      />
    </div>
    <q-tooltip
      v-if="showIntegrationStatus"
    >
      {{ $t('sessions.modals.sessionActivity.linkedToIntegrationTooltip',
            {
              integrationLabel: getIntegrationName(connectedClinic.integration),
            }) }}
    </q-tooltip>
  </q-chip>
</template>
<script>
import { Timestamp } from 'firebase/firestore';
import { get } from 'lodash';
import { mapState } from 'pinia';
import { useTime } from 'src/composables/time';
import Integrations from 'src/mixins/Integrations';
import { auth } from 'src/store/auth';

export default {
  name: 'AppointmentChip',

  mixins: [Integrations],

  props: {
    appointment: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: '1em',
    },
    isGroupSession: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],

  setup() {
    const { getLocaleDateString } = useTime();
    return { getLocaleDateString };
  },

  computed: {
    ...mapState(auth, ['connectedClinic']),

    appointmentInProgress() {
      return this.appointment.status === 'in-progress';
    },

    showIntegrationStatus() {
      // @todo Temporarily hide integration status - enable in HR-1424
      return false;
      // return this.integrationStatusLabel;
    },

    integrationStatusIcon() {
      return this.getIntegrationStatusIcon(this.appointment.status);
    },

    integrationStatusLabel() {
      return this.getIntegrationStatusLabel(this.appointment.status);
    },

    formattedAppointmentDate() {
      const appointmentTs = get(this.appointment, 'scheduledStartTimestamp');
      if (appointmentTs instanceof Timestamp) {
        return this.getLocaleDateString(appointmentTs, { options: { hour: 'numeric', minute: '2-digit' } });
      }
      return '';
    },
  },

  methods: {
    onClick() {
      this.$emit('click');
    }, // onClick()
  },

};
</script>
